import { render, staticRenderFns } from "./typeInfo.vue?vue&type=template&id=7dced0eb&"
import script from "./typeInfo.vue?vue&type=script&lang=js&"
export * from "./typeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports